var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
export function preserveDriveSearchSubAction(currentFilters, newFilters, urlSearch) {
    var queryParams = new URLSearchParams(urlSearch);
    var hadSubActionInUrl = queryParams.has('driveSearchSubAction');
    var isSubActionInNewFilters = newFilters.hasOwnProperty('driveSearchSubAction');
    var filtersToMerge = currentFilters;
    if (!hadSubActionInUrl && !isSubActionInNewFilters) {
        if (currentFilters.driveSearchSubAction === undefined) {
            var driveSearchSubAction = currentFilters.driveSearchSubAction, filtersWithoutSubAction = __rest(currentFilters, ["driveSearchSubAction"]);
            filtersToMerge = filtersWithoutSubAction;
        }
    }
    var updatedFilters = __assign(__assign({}, filtersToMerge), newFilters);
    if (!isSubActionInNewFilters &&
        currentFilters.driveSearchSubAction !== undefined) {
        updatedFilters.driveSearchSubAction = currentFilters.driveSearchSubAction;
    }
    return updatedFilters;
}
